<template>
    <div id="approved-media">
        <perfect-scrollbar class="scroll-area">
            <b-overlay :show="isLoading">
                <p v-if="templates.length === 0 && !isLoading">{{ $t("entities.templates.no-templates-found") }}</p>

                <b-list-group v-else>
                    <b-list-group-item
                        v-for="template in templates"
                        :key="template.id"
                        button
                        class="flex-column align-items-start pb-1 pt-1 border-0"
                        @click="$emit('set-template', template)"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <h5>
                                <font-awesome-icon
                                    v-if="resolveMediaTemplateIcon(template.mediaType)"
                                    :icon="resolveMediaTemplateIcon(template.mediaType)"
                                    class="mr-1 text-secondary"
                                />
                                &#47;{{ template.title }}
                                <span>
                                    <font-awesome-icon
                                        v-if="template.assetId && !template.assetIsLocked"
                                        v-b-tooltip.hover.top="$t('entities.templates.attachment.hover-info')"
                                        :icon="['fas', 'lock-open']"
                                        class="cursor-pointer ml-25"
                                        size="1x"
                                    />
                                    <font-awesome-icon
                                        v-if="template.assetId && template.assetIsLocked"
                                        v-b-tooltip.hover.top="$t('entities.templates.attachment.hover-info-locked')"
                                        :icon="['fas', 'lock']"
                                        class="cursor-pointer ml-25"
                                        size="1x"
                                    />
                                </span>
                            </h5>
                            <b-button
                                v-if="$can('update', 'messageTemplates')"
                                class="btn-icon ml-50"
                                size="sm"
                                variant="light"
                                @click.stop="$emit('manage-media-template', template)"
                            >
                                <font-awesome-icon icon="pen" />
                            </b-button>
                        </div>
                        <b-card-text class="text-secondary">
                            <span class="template-content">{{ template.content }}</span>
                        </b-card-text>
                    </b-list-group-item>
                </b-list-group>
            </b-overlay>
        </perfect-scrollbar>
    </div>
</template>

<script>
import { BListGroup, BListGroupItem, BCardText, BOverlay, BButton, VBTooltip } from "bootstrap-vue";
import { resolveMediaTemplateIcon } from "@/utils/templates";
import { useToast } from "vue-toastification/composition";
import useTemplates from "@/composables/useTemplates";
import { getUserData } from "@/auth/getUserData";

export default {
    components: {
        BListGroup,
        BListGroupItem,
        BCardText,
        BOverlay,
        BButton,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
    },
    setup(props, { emit }) {
        const toast = useToast();

        const { templates, fetchTemplates, isLoading } = useTemplates();

        fetchTemplates({
            params: {
                join: "channels||id",
                fields: "title,content,mediaType,components,assetId,assetIsLocked",
                s: {
                    mediaType: {
                        $notnull: true,
                    },
                    "channels.id": {
                        $eq: props.activeChat.channel.id,
                    },
                },
            },
        });

        return {
            resolveMediaTemplateIcon,
            isLoading,
            templates,

            getUserData,
        };
    },
};
</script>
